export default "__VITE_ASSET__CSlRnp7$__"